import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const onExpired = () => setUser(false);
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const signOut = useCallback(async (path) => {
    try {
      await api.post(path);
    } finally {
      setUser(false);
    }
  }, []);
  const logout = useCallback(() => signOut("/auth/logout"), [signOut]);
  const logoutAll = useCallback(() => signOut("/auth/logout-all"), [signOut]);

  const isAdmin = !!user && user.role === "admin";
  const value = useMemo(() => ({ user, login, logout, logoutAll, isAdmin }), [user, login, logout, logoutAll, isAdmin]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
